import { render, staticRenderFns } from "./personalPhoto.vue?vue&type=template&id=4c1625a6&scoped=true&"
import script from "./personalPhoto.vue?vue&type=script&lang=js&"
export * from "./personalPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1625a6",
  null
  
)

export default component.exports